import { Box, CircularProgress } from '@mui/material';

type Props = {
  size?: string;
};

export function Loader({ size = '64px' }: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        py: '18px',
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
}

export function FillContentLoader() {
  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader />
    </Box>
  );
}
